goog.provide("shadow.js.shim.module$$mui$material$List$default");
shadow.js.shim.module$$mui$material$List$default = shadow.js.shim.module$$mui$material$List.default;
